
<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card flat>
            <v-card-title class="justify-center">{{ addInfo.title }}</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-row dense class="pa-2">
                    <v-col cols="3">Type</v-col>
                    <v-col cols="9">{{ addInfo.prip_type }}</v-col>
                    <v-col cols="3">Description</v-col>
                    <v-col cols="9">{{ addInfo.prip_oms }}</v-col>
                    <v-col cols="3" v-if="addInfo.mail_send === ''">Mail send</v-col>
                    <v-col cols="9" v-if="addInfo.mail_send === ''">{{ addInfo.mail_send }}</v-col>
                </v-row>
                <v-divider/>
                <v-form ref="excelImport" v-model="excelImportValid" v-if="addInfo.mail_send === ''">
                    <v-row dense class="pa-2" >
                        <v-col cols="3">Import accommodations</v-col>
                        <v-col cols="7"><v-file-input v-model="import_file" dense id="myFile" ref="myFile" @change="onFileChange" show-size label="Choose an excel file (.xlsx)" filled prepend-icon="mdi-microsoft-excel" accept=".xlsx" :rules="import_fileRules"></v-file-input></v-col>
                        <v-col cols="2">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="pl-2">mdi-information-variant-circle-outline</v-icon>
                                </template>
                                <span>
                                    Use a excel sheet with one column:<br>
                                    1st row: "Accommodation"<br>
                                    2nd ... n-th row: huis-codes
                                </span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="12" class="font-italic">note: (a successful upload will remove all current accomodations / hosts before importing the new set)</v-col>
                        <v-col cols="3">Hosts</v-col>
                        <v-col cols="9">{{ addInfo.eigns }}</v-col>
                        <v-col cols="3">Accommodations</v-col>
                        <v-col cols="9">{{ addInfo.accos }}</v-col>
                    </v-row>
                </v-form>
                <v-form v-if="addInfo.mail_send !== ''">
                    <v-row dense class="pa-2" >
                        <v-col cols="3" class="pt-4">Add accommodation</v-col>
                        <v-col cols="3"><v-text-field dense v-model="acco" label="Accommodation code"></v-text-field></v-col>
                        <v-col cols="6"></v-col>
                        <v-col cols="12" class="font-italic">note: (The accommodation will be added as opt-in)</v-col>
                        <v-col cols="3">Hosts</v-col>
                        <v-col cols="9">{{ addInfo.eigns }}</v-col>
                        <v-col cols="3">Accommodations</v-col>
                        <v-col cols="9">{{ addInfo.accos }}</v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <!-- <v-btn color="success" :disabled="addInfo.eigns_send > 0||excelImportValid||addInfo.eigns===0" @click="sendEmail">Send</v-btn> -->
                <v-btn small color="success"  :disabled="!excelImportValid" @click="importAccos" v-if="addInfo.mail_send === ''">Import</v-btn>
                <v-btn small color="success"  :disabled="acco===''" @click="addOneAcco" v-if="addInfo.mail_send !== ''">Add acco</v-btn>
                <v-btn small color="primary" @click="closePripAcco">Close</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                acco: "",
                addInfo : {
                    title: "test",
                    prip_nr: 0,
                    mltp_nr: 0
                },
                excelImportValid: false,
                import_url: null,
                import_src: null,
                import_file: null,
                import_fileRules: [
                    v => !!v || "An excel (.xlsx) file is required"
                ]
            }  
        },
        methods: {
            onFileChange() {
                // var deze = this;
                const file_object = this.import_file;
                if (file_object !== null) {
                    this.import_url = URL.createObjectURL(file_object);
            
                    let reader = new FileReader();
            
                    reader.readAsDataURL(file_object);
                    reader.onload = evt => {
                        this.import_src = evt.target.result;
                    }

                    reader.onerror = evt => {
                        console.error(evt);
                    }  
                } else  {
                    this.import_url = null;
                }   
            },
            getPripAcco(prip_nr) {
                this.$axios.post("ares/json/ares/syst/prip/getPripAcco.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPripAcco"
                    },
                    getPripAcco: {
                        prip_nr: prip_nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.addInfo = res.data.getPripAcco;
                        this.dialog = true;
                    }
                });
            },
            importAccos() {
                this.$axios.post("ares/json/ares/syst/prip/importPripAccos.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "importPripAccos"
                    },
                    importPripAccos: {
                        prip_nr: this.addInfo.prip_nr,
                        import_data: this.import_src
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.importPripAccos.text,
                            color: res.data.importPripAccos.color
                        });
                        if (res.data.importPripAccos.color === "success") {
                            this.getPripAcco(this.addInfo.prip_nr)
                            this.$emit("reload")
                        }
                    }
                });
            },
            addOneAcco() {
                this.$axios.post("ares/json/ares/syst/prip/addPripAcco.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addPripAcco"
                    },
                    addPripAcco: {
                        prip_nr: this.addInfo.prip_nr,
                        acco: this.acco
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.addPripAcco.text,
                            color: res.data.addPripAcco.color
                        });
                        if (res.data.addPripAcco.color === "success") {
                            this.$emit("reload")
                            this.closePripEmail()
                        }
                    }
                });
            },
            closePripAcco() {
                this.dialog = false
            }
        }
    };
</script> 

<style scoped>
</style>